import tw from 'twin.macro';

export const BreadcrumbsWrapper = tw.div`
  text-xs text-neutrals-n9
  mb-11
  pr-96
`;
